import { render } from "./i18n-flags.vue?vue&type=template&id=4ce75c92"
import script from "./i18n-flags.vue?vue&type=script&lang=js"
export * from "./i18n-flags.vue?vue&type=script&lang=js"

import "./i18n-flags.vue?vue&type=style&index=0&id=4ce75c92&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__